import React, { useMemo } from 'react';
import type { IProps } from './types';
import Select from '../../../../../../../shared/design-system/components/select';
import { Placement } from '../../../../../../../shared/design-system/components/overlay';

const TaskAssignee: React.FC<IProps> = ({
  selectedAssignee,
  onAssigneeChange,
  taskAssigneeList,
  disabled = false,
}) => {
  const getKey = (item) => (item.userName.trim() ? item.userName : item.email);

  const options = useMemo(
    () =>
      taskAssigneeList?.map((item) => ({
        key: getKey(item),
        value: item.id,
      })),
    [taskAssigneeList],
  );

  return (
    <div className="task-assignee">
      <span className="semibold-1 gray-txt-15">Task Assignee</span>
      <div className="d-flex task-assignee__select">
        <Select<{
          key: string;
          value: number;
        }>
          options={options}
          selectedOptionKey={
            options?.find((item) => item.value === selectedAssignee)?.key
          }
          optionRenderer={(option) => <span>{option?.key}</span>}
          selectedOptionRenderer={([option]) => <span>{option?.key}</span>}
          onChange={([option]) => onAssigneeChange(option)}
          placement={Placement.Top}
          className="task-assignee__select-dropdown"
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default TaskAssignee;
